class ProductCardDetailed extends HTMLElement {
  connectedCallback () {
    const onlyDefaultVariant = this.dataset.productOnlyDefaultVariant === 'true'
    if (onlyDefaultVariant) return

    // Parse the comma-separated string of variant IDs
    const variantIdsString = this.dataset.productVariants
    this.variantIds = variantIdsString.split(',').filter(id => id.trim() !== '')

    this.viewport = this.querySelector('.product-card-detailed__image-carousel-viewport')
    this.slides = this.querySelectorAll('.product-card-detailed__image-carousel-slide')

    this.cardLink = this.querySelector('.product-card-detailed__pseudo-link')
    this.cardLinkInitialUrl = this.cardLink.dataset.initialUrl
    this.defaultVariantId = this.dataset.defaultVariantId

    this.initColorSwatches()
    this.currentSlide = 0
  }

  scrollToSlide (index) {
    if (index < 0 || index >= this.slides.length) return

    this.currentSlide = index
    const translateValue = -100 * index

    this.viewport.style.transform = `translateX(${translateValue}%)`
  }

  initColorSwatches () {
    const colorSwatchButtons = this.querySelectorAll('.product-card-detailed__variant-button')
    let activeButton = null

    colorSwatchButtons.forEach((button, index) => {
      const variantId = button.dataset.variantId
      const variantLink = button.dataset.variantLink

      // Set initial active state based on default variant or first variant
      if (this.defaultVariantId && this.cardLink.getAttribute('href').includes(variantId)) {
        button.classList.add('active')
        activeButton = button
      } else if (!this.defaultVariantId && index === 0) {
        button.classList.add('active')
        activeButton = button
        // Update the card link URL to the first variant
        if (variantLink) {
          this.cardLink.setAttribute('href', variantLink)
          this.cardLink.dataset.initialUrl = variantLink
        }
        // Scroll to first slide
        this.scrollToSlide(0)
      }

      button.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        // Update active state
        if (activeButton) {
          activeButton.classList.remove('active')
        }
        button.classList.add('active')
        activeButton = button

        // Update the card link URL
        if (variantLink) {
          this.cardLink.setAttribute('href', variantLink)
        } else {
          this.cardLink.setAttribute('href', this.cardLinkInitialUrl)
        }

        // Find the matching slide index
        const slideIndex = Array.from(this.slides).findIndex(
          slide => slide.dataset.variantId === variantId,
        )

        if (slideIndex !== -1) {
          this.scrollToSlide(slideIndex)
        }
      })
    })
  }
}

if (!customElements.get('product-card-detailed')) {
  customElements.define('product-card-detailed', ProductCardDetailed)
}
